var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.32 26.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        opacity: .6;\n        stroke: #8af3e5;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.43,5.76c4.09,5.67,2.8,13.58-2.87,17.67-5.67,4.09-13.58,2.8-17.67-2.87C-1.2,14.89,.09,6.98,5.76,2.89,11.43-1.2,19.34,.09,23.43,5.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.2eb047678a6712753397c3bd67c3781a.svg";
export { ForwardRef as ReactComponent };